import { decode, encode } from "js-base64";

export default function cookieUtils(): any {
  function setBase64Cookie(key: string, value: any) {
    const secure = window.location.protocol == "https:" ? ";Secure" : "";
    document.cookie = key + "=" + encode(value) + ";path=/;SameSite=Lax" + secure;
  }

  function getBase64Cookie(key: string, loeschen = true) {
    const cookieGefunden = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    const cookieValue = cookieGefunden ? cookieGefunden.pop() : "";
    if (loeschen) {
      document.cookie = key + "=" + cookieValue + "; max-age=0; path=/;";
    }
    return cookieValue ? decode(cookieValue) : undefined;
  }

  const setCookie = (name: string, value: string, days?: number) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    const secure = window.location.protocol == "https:" ? ";Secure" : "";
    document.cookie = name + "=" + (value || "") + expires + ";path=/;SameSite=Lax" + secure;
  };
  const getCookie = (name: string) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (const c0 of ca) {
      let c = c0;
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  return {
    setCookie,
    getCookie,
    setBase64Cookie,
    getBase64Cookie,
  };
}
